import React from "react";

export default class ScreenBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidUpdate(previous) {
    if (previous.resetKey !== this.props.resetKey && this.state.failed) this.setState({ failed: false });
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <section role="alert" className="screen-recovery">
      <h2>This view couldn’t be displayed</h2>
      <p>Retry this view. If the problem continues, reload the application. Unsaved edits in this view may need to be restored from the device draft.</p>
      <button onClick={() => this.setState({ failed: false })}>Retry view</button>{" "}
      <button onClick={() => window.location.reload()}>Reload application</button>
    </section>;
  }
}
